<template>
  <div class="user-container">
    <component :is="conponentActive" />
  </div>
</template>

<script>
import { getUserType } from '@/utils/auth'
import { UserType } from '@/common/constant'
import HeaderUserStudent from '@/views/pages/student/layout/header-user'
import HeaderUserTeacher from '@/views/pages/teacher/layout/header-user'

export default {
  name: 'AppHeaderUser',

  computed: {
    /**
     * Trả về component theo giáo viên hoặc học sinh
     */
    conponentActive () {
      const typeActive = getUserType()
      let component = null

      if (typeActive === UserType.Student) {
        component = HeaderUserStudent
      } else {
        component = HeaderUserTeacher
      }
      return component
    }
  }
}
</script>

<style lang="scss" scoped>
.user-container {
  display: flex;
  height: 100%;
  align-items: center;
  color: $color-neutral-light-4;
}
</style>
